import { CSSProperties } from "react";
import { Product } from "../../types/Product";
import { useProductFlags } from "../../utils/ProductUtils";
import classNames from "classnames";
import "./style.scss";

export function Flags({
  product,
  inline,
  style = undefined,
  className
}: {
  product: Product;
  inline: boolean;
  style?: CSSProperties;
  className?: string;
}) {
  const flags = useProductFlags(product);
  const classes = ["flags"];
  if (inline) {
    classes.push("inline-flags");
  }
  if (className) {
    classes.push(className);
  }
  return flags.length > 0 ? (
    <span className={classNames(classes)} style={style}>
      {flags}
    </span>
  ) : null;
}
